import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["billingScheme", "tiersSection", "container", "tier", "position", "destroy", "amountLabel", "amountInput", "amountSection"]
  static values = { synced: Boolean }

  connect() {
    this.toggleTiers()
    this.updatePositions()
  }

  toggleTiers() {
    const billingScheme = this.billingSchemeTarget.value

    // 階層別料金セクションの表示/非表示
    if (billingScheme === "tiered") {
      this.tiersSectionTarget.classList.remove("hidden")
    } else {
      this.tiersSectionTarget.classList.add("hidden")
    }

    // 金額フィールドの表示/非表示
    this.updateAmountSection(billingScheme)
  }

  updateAmountSection(billingScheme) {
    if (!this.hasAmountSectionTarget) return

    if (billingScheme === "tiered") {
      // 階層別課金の場合は金額フィールドを非表示にし、0を設定
      this.amountSectionTarget.classList.add("hidden")
      if (this.hasAmountInputTarget) {
        this.amountInputTarget.value = 0
      }
    } else {
      // それ以外は表示
      this.amountSectionTarget.classList.remove("hidden")
      this.updateAmountLabel(billingScheme)
    }
  }

  updateAmountLabel(billingScheme) {
    if (!this.hasAmountLabelTarget) return

    let labelText = "金額（円）"

    if (billingScheme === "per_unit") {
      labelText = "単価（円/契約）"
    }

    this.amountLabelTarget.innerHTML = `${labelText}<span class="text-red-500">*</span>`
  }

  addTier() {
    if (this.syncedValue) return

    const newIndex = Date.now()
    const template = this.getTierTemplate(newIndex)
    this.containerTarget.insertAdjacentHTML("beforeend", template)
    this.updatePositions()
  }

  removeTier(event) {
    if (this.syncedValue) return

    const tier = event.target.closest('[data-plan-tiers-target="tier"]')
    const destroyField = tier.querySelector('[data-plan-tiers-target="destroy"]')

    if (destroyField && destroyField.name && /\[\d+\]/.test(destroyField.name)) {
      // 既存レコードの場合は_destroyフラグをセット
      destroyField.value = "1"
      tier.style.display = "none"
    } else {
      // 新規レコードの場合は完全に削除
      tier.remove()
    }

    this.updatePositions()
  }

  updatePositions() {
    let position = 0
    this.tierTargets.forEach(tier => {
      if (tier.style.display !== "none") {
        const positionField = tier.querySelector('[data-plan-tiers-target="position"]')
        if (positionField) {
          positionField.value = position
          position++
        }
      }
    })
  }

  getTierTemplate(index) {
    return `
    <div class="plan-tier-row border border-gray-200 rounded-lg p-4 mb-4" data-plan-tiers-target="tier">
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">上限数</label>
          <input type="number"
                 name="plan[plan_tiers_attributes][${index}][up_to]"
                 class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                 min="1"
                 step="1"
                 placeholder="5（空欄で無制限）">
          <p class="mt-1 text-xs text-gray-500">空欄で無制限</p>
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">固定額（円）</label>
          <input type="number"
                 name="plan[plan_tiers_attributes][${index}][flat_amount]"
                 class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                 min="0"
                 step="1"
                 placeholder="5000">
        </div>

        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">単価（円）</label>
          <input type="number"
                 name="plan[plan_tiers_attributes][${index}][unit_amount]"
                 class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                 min="0"
                 step="1"
                 placeholder="1000">
        </div>

        <div class="flex items-end">
          <button type="button"
                  class="inline-flex items-center rounded-md bg-red-50 px-3 py-2 text-sm font-semibold text-red-700 hover:bg-red-100"
                  data-action="click->plan-tiers#removeTier">
            削除
          </button>
        </div>
      </div>

      <input type="hidden" name="plan[plan_tiers_attributes][${index}][position]" value="0" data-plan-tiers-target="position">
      <input type="hidden" name="plan[plan_tiers_attributes][${index}][_destroy]" value="" data-plan-tiers-target="destroy">
    </div>`
  }
}
